module.exports = __webpack_public_path__ + "static/img/wxcode.d117313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxcode.png
// module id = qwda
// module chunks = 0